import { useTheme } from '../context/ThemeContext'
import { useLocation, useNavigate } from 'react-router-dom'

function TabNav() {
    const { theme } = useTheme()
    const location = useLocation()
    const navigate = useNavigate()

    const tabs = [
        { name: 'Production', path: '/production' },
        { name: 'LEEVIEW', path: '/leeview' },
        { name: 'Map', path: '/map' },
        { name: 'Financials', path: '/financials' },
        { name: 'Workovers', path: '/workovers' },
        { name: 'Well Analysis', path: '/well-analysis' },
        { name: 'Well Review', path: '/well-review' },
        { name: 'Sales/Tank', path: '/tanks' },
        { name: 'Hedge', path: '/hedge' },
        { name: 'Downloads', path: '/downloads' }
    ]

    const isActive = (path) => {
        if (path === '/production' && (location.pathname === '/' || location.pathname === '/production')) {
            return true
        }
        if (path === '/financials' && location.pathname.startsWith('/financials')) {
            return true
        }
        if (path === '/workovers' && location.pathname.startsWith('/workovers')) {
            return true
        }
        if (path === '/map' && location.pathname.startsWith('/map')) {
            return true
        }
        if (path === '/leeview' && location.pathname.startsWith('/leeview')) {
            return true
        }
        if (path === '/well-analysis' && location.pathname.startsWith('/well-analysis')) {
            return true
        }
        if (path === '/well-review' && location.pathname.startsWith('/well-review')) {
            return true
        }
        if (path === '/tanks' && location.pathname.startsWith('/tanks')) {
            return true
        }
        if (path === '/hedge' && location.pathname.startsWith('/hedge')) {
            return true
        }
        if (path === '/downloads' && location.pathname.startsWith('/downloads')) {
            return true
        }
        return location.pathname === path
    }

    return (
        <div className={`flex overflow-x-auto scrollbar-hide border-b-2 ${theme === 'dark' ? 'border-slate-800' : 'border-gray-200'} pb-0 mb-4 sm:mb-6 -mx-2 px-2 sm:mx-0 sm:px-0`}>
            {tabs.map((tab) => (
                <button
                    key={tab.path}
                    onClick={() => navigate(tab.path)}
                    className={`flex-shrink-0 px-3 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm font-medium rounded-t-lg transition-all whitespace-nowrap ${
                        isActive(tab.path)
                            ? theme === 'dark'
                                ? 'bg-slate-900 text-white border-b-4 border-blue-500'
                                : 'bg-white text-gray-900 border-b-4 border-blue-600'
                            : theme === 'dark'
                                ? 'bg-transparent text-gray-400 hover:text-gray-200'
                                : 'bg-transparent text-gray-600 hover:text-gray-900'
                    }`}
                >
                    {tab.name}
                </button>
            ))}
        </div>
    )
}

export default TabNav
